const decimal = value => Number(String(value || 0).replace(',', '.')) || 0;

export const optionistReportPercent = (reportTypes, reportType) =>
  Number(
    reportTypes?.find(type => String(type.id) === String(reportType))
      ?.percent || 0
  );

export const distributeOptionistPercentages = (rows, percent) => {
  if (!rows.length) return [];

  const totalHundredths = Math.round(decimal(percent) * 100);
  const sharedHundredths = Math.round(totalHundredths / rows.length);

  return rows.map((row, index) => {
    const value =
      index === rows.length - 1
        ? totalHundredths - sharedHundredths * (rows.length - 1)
        : sharedHundredths;

    return {
      ...row,
      porcentagem_real: (value / 100).toFixed(2),
    };
  });
};

export const optionistReportTotal = rows =>
  rows.reduce((total, row) => total + decimal(row.porcentagem_real), 0);

export const optionistReportExceedsLimit = (rows, reportTypes) => {
  const reportType = rows.find(
    row => row.tipo_laudo_opcionista
  )?.tipo_laudo_opcionista;
  if (!reportType) return false;

  const limit = optionistReportPercent(reportTypes, reportType);
  return optionistReportTotal(rows) > limit + 0.000001;
};
